import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },

  leverage_amount_received: {
    name: 'Leverage amount received',
    isStatic: false
  },
  source_bic: {
    name: "Source's BIC",
    isStatic: false
  },
  source_lei: {
    name: "Source's LEI",
    isStatic: false
  },
  source_name: {
    name: "Source's name",
    isStatic: false
  },
  borrowing_source_flag: {
    name: 'Borrowing source flag',
    isStatic: false,
    withoutLetter: true
  }
};

export function BorrowingSource({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.BORROWING_SOURCE,
    onChangeFund,
    schema: schema.BORROWING_SOURCE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.BORROWING_SOURCE?.field_names || [],
    columnLables,
    order: 243,
    isMultiFunds,
    funds,
    tableName: 'BORROWING_SOURCE'
  });

  return (
    <StyledTables id="fca-reporttables-borrowing-source-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-borrowing-source-table-${index + 1}`}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
          key={index + 'BORROWING_SOURCE'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
        />
      ))}
    </StyledTables>
  );
}
